import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IWorkbenchAssignmentService = ( createDecorator('WorkbenchAssignmentService'));
export { IWorkbenchAssignmentService };
